/**
 * Reviews API — always uses GET/POST `/api/v1/reviews` on the backend.
 */
import httpClient from './httpClient';
import {
  type Review,
  type ReviewFilter,
  type ReviewListResponse,
  type ReviewSubmitPayload,
} from './types';

const filterToQuery = (filter: ReviewFilter): Record<string, string> | undefined => {
  if (filter === 'five') return { min_rating: '5' };
  if (filter === 'fourPlus') return { min_rating: '4' };
  return undefined;
};

export const fetchReviews = async (
  filter: ReviewFilter = 'all',
): Promise<ReviewListResponse> => {
  const { data } = await httpClient.get<ReviewListResponse>('/reviews', {
    params: filterToQuery(filter),
  });
  return data;
};

export const submitReview = async (payload: ReviewSubmitPayload): Promise<Review> => {
  const { data } = await httpClient.post<Review>('/reviews', payload);
  return data;
};
